import { render, staticRenderFns } from "./BodyPartVolume.vue?vue&type=template&id=77eb7693&"
import script from "./BodyPartVolume.vue?vue&type=script&lang=js&"
export * from "./BodyPartVolume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports